import { create } from "zustand";
import { appLoginDetails, moengageEventDetails } from "../api_layer";

const useAppLoginStore = create((set) => ({
  appLoginDetails: [],
  moengageEvents:[],
  isLoading:false,
  totalItems: 0,
  totalMoeItems: 0,
  isError :null,
  fetchAppLoginDetails: async (id, pageNumber) => {
    try {
      set({isLoading:true });
      const response = await appLoginDetails(id, pageNumber);
      set({
        appLoginDetails: response?.data?.allAppLoginDetails,
        totalItems: response?.data?.totalCount, 
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      set({ isLoading: false });
    }
  },

  fetchMoengageDetails: async (caseId, pageNumber) => {
    try {
      set({isLoading:true });
      const response = await moengageEventDetails(caseId, pageNumber);
      set({
        moengageEvents: response?.data?.eventDetails,
        totalMoeItems: response?.data?.totalCount, 
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      set({ isLoading: false });
    }
  },
}));

export default useAppLoginStore;
